var IpcPthPadGeneratorData = require('./ipcPthPadGeneratorData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PathData = require('../../../svg/pathData.js');
var EllipseData = require('../../../svg/ellipseData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var PthComponentAttribute = require('./pthComponentAttribute.js');
var IPCRules = require('../ipcRules');
var IPCPthFootprintCalculator = require('./pthCalculator.js');

var DipData = function(position, angle, init) {
    IpcPthPadGeneratorData.apply(this, arguments);

    this.leadSpan = this.value("leadSpan", true);
    this.terminalThickness = this.value("terminalThickness", true);
    this.bodyOffset = this.value("bodyOffset", true);

    this.update3dModelNonTriggerList.push("densityLevel");
    this.nonTransformedSegmentedGeometry.addTrigger(this.leadSpan);
    this.nonTransformedSegmentedGeometry.addTrigger(this.terminalThickness);
};

lib_core.inherit(DipData, IpcPthPadGeneratorData);
lib_core.JsonParser.registerClass(DipData, "DipData");

module.exports = DipData;

DipData.prototype.setupMinMaxPtrMap = function() {
    IpcPthPadGeneratorData.prototype.setupMinMaxPtrMap.call(this);

    this.minMaxPointerMap["bodyOffsetAndHeight"] = [this.bodyOffset, this.bodyHeightMax];
    this.validationMap["leadSpan"] = [this.leadSpan];
    this.validationMap["terminalThickness"] = [this.terminalThickness];
};

DipData.prototype.getTerminalDiameter = function() {
    return Math.sqrt(this.terminalWidth() * this.terminalWidth() + this.terminalThickness() * this.terminalThickness());
}

/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
DipData.prototype.getPads = function(absolutePositions) {
    var nRow = this.horizontalPadCount() / 2;
    var motif = this.getMotif();
    var pads = [];

    for(var i = 0; i < 2 * nRow; i++) {
        var col = Math.floor(i / nRow);
        var row = i % nRow;
        if (col % 2 == 1) row = nRow - 1 - row; // in odd columns change order from bottom to top

        var pad = motif.clone();
        pad.move(new lib_geometry.Coord((-0.5 + col) * this.leadSpan(), ((nRow - 1) / 2 - row) * this.verticalPinPitch()));
        pads.push(pad);
    }

    this.updatePads(pads, absolutePositions);

    return pads;
};

/**
 * Calculate silkscreen for selected component. Silkscreen is calculated from body and pads geometry.
 * @param  {array} pads Pads calculated from getPads() function.
 * @return {array} Array of silkscreen data
 */
DipData.prototype.getSilkscreen = function(pads) {
    if(pads.length === 0) return;

    var silkscreen = [];
    var body = this.getBodyForSilkscreen();

    ////////////////////
    //   Pin Marker   //
    ////////////////////

    silkscreen.push(this.getPinOneMarker(pads[0], body, true));

    //////////////////////////////
    //   Component Silkscreen   //
    //////////////////////////////

    this.populateSilkscreenForBody(body, pads[0], pads[this.horizontalPadCount() / 2 - 1], silkscreen);

    return silkscreen;
};
